<script>
	import Header from './header.svelte';
	import Ecosystem from './ecosystem_section.svelte';
	import CoreValues from './core_values_section.svelte';
	import Ourprograms from './program_section/our_programs_section.svelte';
	import WhyDraperSection from './why_draper_section.svelte';
	import SupportedProject from './supported_project/supported_project.svelte';
	import Testimonials from './testimonials.svelte';
	import {playAnimation} from '../store';
	import Animation from './starting_animation/index.svelte';

	let scrollY;
	let viewPortHeight;
// <!-- Google Tag Manager -->
	(function(w, d, s, l, i) {
    w[l]=w[l]||[]; w[l].push({'gtm.start':
    new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
    const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
// <!-- End Google Tag Manager -->
</script>

<svelte:window bind:scrollY={scrollY} bind:innerHeight={viewPortHeight} />

{#if $playAnimation}
	<Animation />
{:else}
	<div class="position-div">
		<Header />
		<SupportedProject/>
		<WhyDraperSection bind:scrollY {viewPortHeight}/>
		<Ourprograms />
		<CoreValues />
		<Testimonials />
		<Ecosystem bind:scrollY {viewPortHeight}/>
	</div>
{/if}

<style>
	.position-div {
		position: relative;
		height: 100%;
	}
</style>
